import React from "react";
import "./education.css";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import Typography from "@mui/material/Typography";
import { experience } from "../../experience";
import { education } from "../../education.js";
import { useContext } from "react";
import { ThemeContext } from "../../context";

const Education = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="e">
      <div className="e-header">
        <h1> Education & Experience </h1>
        <div className="line-wrapper">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="line"></div>
        </div>
      </div>

      <div className="e-wrapper">
        <div className="e-left">
          {education.map((item, index) => (
            <Timeline>
              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  align="right"
                  variant="body2"
                  color="text.secondary"
                  fontFamily="Poppins"
                  style={{ color: darkMode && "#fff" }}
                >
                  {item.date}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  👩‍🎓
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography
                    variant="h6"
                    component="span"
                    fontFamily="Poppins"
                  >
                    {item.title}
                  </Typography>
                  <Typography fontFamily="Poppins" fontSize="12px" color="gray">
                    {item.location}
                  </Typography>
                  <Typography
                    fontFamily="Poppins"
                    fontSize="15px"
                    fontWeight="bold"
                  >
                    {item.degree}
                  </Typography>
                  <Typography fontFamily="Poppins" fontSize="12px">
                    {item.courses}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          ))}
        </div>

        <div className="e-right">
          {experience.map((item) => (
            <Timeline>
              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  align="right"
                  variant="body2"
                  color="text.secondary"
                  fontFamily="Poppins"
                  style={{ color: darkMode && "#fff" }}
                >
                  {item.date}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  👩‍💻
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography
                    variant="h6"
                    component="span"
                    fontFamily="Poppins"
                  >
                    {item.company}
                  </Typography>
                  <Typography fontFamily="Poppins" fontSize="12px" color="gray">
                    {item.location}
                  </Typography>
                  <Typography
                    fontFamily="Poppins"
                    fontSize="15px"
                    fontWeight="bold"
                  >
                    {item.position}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Education;
